import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { User } from '../../auth/models/User';

@Component({
  selector: 'pioneer-header',
  templateUrl: 'header.component.html'
})
export class HeaderComponent implements OnInit {

  userIsLoggedIn: Observable<boolean>;
  user: User;

  constructor(
    private authenticationStore: AuthenticationStore,
    private router: Router
  ) {}

  ngOnInit() {
    this.userIsLoggedIn = this.authenticationStore.isLoggedIn();
    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    })
  }

  onLogout() {
    this.authenticationStore.logout();
    if (this.authenticationStore.isExternalLogin()) {
      this.router.navigate([ 'external-login-expired' ]);
    } else {
      this.router.navigate([ 'login' ]);
    }
  }

  get email() {
    return {
      email: this.user.email
    };
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/navigation/header/header.component.ts